export enum PromoType {
  unknown = 0,
  flash = 1,
  text = 2,
  xml = 3,
  feed_text = 4,
  teaser = 5,
  coupon = 6,
  dynamic = 7,
  LinkAds = 8,
  KeywordAds = 9,
  Clickunder = 10,
  productFeed = 11,
  image = 12,
  HTML5 = 15,
  iframe = 16,
}
